import { Box, Typography } from '@mui/material';
import { useRef } from 'react';
import { useSnackbar } from 'notistack';
import DatePickerMoment, { DatePickerMomentProps } from './DatePickerMoment';
import moment from 'moment';

export type onDateChange = DatePickerMomentProps['onChange'];
export interface PeriodFilterProps {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  onStartDateChange: onDateChange;
  onEndDateChange: onDateChange;
}

const PeriodFilter = ({
  onStartDateChange,
  onEndDateChange,
  startDate,
  endDate,
}: PeriodFilterProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const hasShownToastRef = useRef(false);

  const handleStartDateChange: onDateChange = (newValue) => {
    if (newValue && moment(newValue).isValid()) {
      const selectedDate = moment(newValue).startOf('day');
      
      if (endDate && endDate.isValid()) {
        const end = moment(endDate).startOf('day');
        if (selectedDate.isAfter(end)) {
          if (!hasShownToastRef.current) {
            enqueueSnackbar('Start date cannot be greater than end date', {
              variant: 'error',
            });
            hasShownToastRef.current = true;
          }
          return;
        }
      }
    }
    
    hasShownToastRef.current = false;
    onStartDateChange(newValue);
  };

  const handleEndDateChange: onDateChange = (newValue) => {
    if (newValue && startDate && moment(newValue).isValid() && startDate.isValid()) {
      const start = moment(startDate).startOf('day');
      const end = moment(newValue).startOf('day');
      
      if (end.isBefore(start)) {
        if (!hasShownToastRef.current) {
          enqueueSnackbar('Start date cannot be greater than end date', {
            variant: 'error',
          });
          hasShownToastRef.current = true;
        }
        return;
      }
    }
    
    hasShownToastRef.current = false;
    onEndDateChange(newValue);
  };

  return (
    <Box>
      <Typography fontSize={'1rem'} fontWeight={'bold'} marginBottom={1.4}>
        Date Range
      </Typography>
      <DatePickerMoment
        containerSx={{ mb: 2 }}
        label={'Start Date'}
        value={startDate}
        onChange={handleStartDateChange}
      />
      <DatePickerMoment 
        label={'End Date'} 
        value={endDate} 
        onChange={handleEndDateChange}
      />
    </Box>
  );
};

export default PeriodFilter;
